import TopSectionWithoutFilter from '@/TRC/components/TopSections/topSectionWithoutFilter';
import TRC_PAGE_CATEGORIES from '../../../constants/trcCategories';
import TRCHorizontalScrollComponent from '@/TRC/components/horizontalDivComponent';
import { TRC_ROUTES } from '@/TRC/constants/trcRoutes';


const TRCVideosSection = ({ videos }) => {
	return (
		<section className="w-100 pt-1 pt-lg-0" style={{ background: '#27272a' }}>
			<TopSectionWithoutFilter category={TRC_PAGE_CATEGORIES.VIDEOS} />
			<TRCHorizontalScrollComponent contents={videos} route={TRC_ROUTES.VIDEOS.toLowerCase()} className="px-lg-5" fixedWidth />
		</section>
	);
};

export default TRCVideosSection;
